export const ImagePaths = {
    defaultUser: '/assets/user.png'
};



